import request from "../request";

/**
 * Состояние корзины
 * @return {Promise}
 */
export const getCart = ({ eventId }) => {
  return request({
    url: "/event/cart/get-cart",
    addCSRFToken: true,
    needOverlay: false,
    data: {
      event_id: eventId || 0,
    },
  });
};

/**
 * Добавление в корзину
 * @return {Promise}
 */
export const addToCart = ({ eventId, sid, viewId, price_view_id }) => {
  return request({
    url: "/event/cart/add",
    addCSRFToken: true,
    data: {
      event_id: eventId,
      sid,
      view_id: viewId,
      price_view_id,
    },
  });
};

/**
 * Удаляет билет из корзины
 * @param {Object} props
 * @param {number} props.eventId
 * @param {string} props.sid
 * @param {number} props.viewId
 * @param {string} props.uid
 * @return {Promise<import("../types/cart").RemoveEventCartResponse>}
 */
export const removeFromCart = ({ eventId, sid, viewId, uid }) => {
  return request({
    url: "/event/cart/remove",
    addCSRFToken: true,
    type: "DELETE",
    data: {
      event_id: eventId,
      sid,
      uid,
      view_id: viewId,
    },
  });
};

/**
 * Удалить мероприятия из заказа
 * @return {Promise}
 */
export const removeEventFromOrder = ({ eventId, orderId }) => {
  return request({
    url: "/event/cart/remove-event",
    data: {
      event_id: eventId,
      order_id: orderId,
    },
  });
};

export const cancelAll = () => {
	return request({
		url: "/order/cancel-all",
	})
}
/**
 * Меняет тип билета
 * @return {Promise}
 */
export const changePriceId = ({
  eventId,
  orderId,
  uid,
  priceId,
  categoryId,
}) => {
  return request({
    url: "/event/cart/change-price-id",
    data: {
      event_id: eventId,
      order_id: orderId,
      uid: uid,
      price_id: priceId,
      loyalty_category_id: categoryId,
    },
  });
};

export const saveExtraInfo = ({ uid, text }) => {
  return request({
    url: "/event/cart/save-extra-info",
    data: {
      uid,
      text,
    },
  });
};
